import { Button, cnMixSpace } from 'uikit';

import { useCallback, useState } from 'react';

import { useSetCatalogUerBaseCostProperties } from './hooks';
import { UpdateCatalogUerBaseCostPropertiesModal } from './UpdateCatalogUerBaseCostPropertiesModal';

interface IUpdateCatalogUerBaseCostPropertiesProps {
    catalogId?: number;
    checkedRowIds: number[];
    resetCheckedRows: () => void;
    refreshTable: () => void;
}

export const UpdateCatalogUerBaseCostProperties = ({
    checkedRowIds,
    catalogId,
    refreshTable,
    resetCheckedRows,
}: IUpdateCatalogUerBaseCostPropertiesProps) => {
    const [isModalOpened, setIsModalOpened] = useState(false);

    const toggleModalState = useCallback(() => {
        setIsModalOpened((prev) => {
            if (prev) {
                resetCheckedRows();
            }

            return !prev;
        });
    }, [resetCheckedRows]);

    const { makeRequest } = useSetCatalogUerBaseCostProperties({
        catalogId,
        checkedRowIds,
        refreshTable,
        resetCheckedRows,
    });

    return (
        <>
            <Button
                className={cnMixSpace({ mR: 's' })}
                label="Заполнить"
                view="secondary"
                size="xs"
                onClick={toggleModalState}
            />
            {isModalOpened && (
                <UpdateCatalogUerBaseCostPropertiesModal makeRequest={makeRequest} onClose={toggleModalState} />
            )}
        </>
    );
};

UpdateCatalogUerBaseCostProperties.displayName = 'UpdateCatalogUerBaseCostProperties';
